var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ota-p14 inline-block rounded text-sm text-white px-5 py-3",class:_vm.classes,on:{"click":_vm.onClick}},[_c('span',{domProps:{"textContent":_vm._s(_vm.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }